module.exports = __webpack_public_path__ + "327a489b42868abad5d02369133efe85.png";